import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  MANUFACTURING_SCHEDULE_REPORT_GET_JOB_LIST: createSagaAction(
    'MANUFACTURING_SCHEDULE_REPORT_GET_JOB_LIST'
  ),
  MANUFACTURING_SCHEDULE_REPORT_GET_FULL_REPORT: createSagaAction(
    'MANUFACTURING_SCHEDULE_REPORT_GET_FULL_REPORT'
  )
}

// Action Creators
export const actions = {
  manufacturingScheduleReportGetJobList: ({ filters }) => ({
    type: constants.MANUFACTURING_SCHEDULE_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  manufacturingScheduleReportGetFullReport: ({ filters }) => ({
    type: constants.MANUFACTURING_SCHEDULE_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.MANUFACTURING_SCHEDULE_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.MANUFACTURING_SCHEDULE_REPORT_GET_JOB_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingJobList: false,
        jobList: action.payload
      }

    case constants.MANUFACTURING_SCHEDULE_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.MANUFACTURING_SCHEDULE_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/jobs/manufacturingScheduleReportActions.js